module.exports = __webpack_public_path__ + "static/baked_macaron_rainbow-ab971cdfb840c252408a2a2a66b22e69.jpg";